// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"Checkbox_checkboxContainer__2f7UC","checkboxLabel":"Checkbox_checkboxLabel__1OUPV","box":"Checkbox_box__3vQnp","checked":"Checkbox_checked__2LpC8"};